import { useSelector } from 'react-redux'

export default function useToken() {
    const userData = useSelector((state: any)=>(state.user.userData))
    const token = userData?.token || localStorage.getItem('token') || ''
    
  return  {token}
}
